import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarService } from '../../../../services/snackBar.service';
import { CalibrationBalanceVariablePoints } from '../../../../model/calibrationBalance';
import { Subject } from 'rxjs';
import { MatCheckboxChange } from '@angular/material/checkbox';

export interface DialogDataCalibrationSelectPoints {
  points: { uuidConfig: string; uuidPattern: string; points: number[] }[];
  pointsSelect: { uuidConfig: string;  uuidPattern: string; point: number }[];
  isAsFound: boolean;
}

@Component({
  selector: 'app-calibration-balance-edit-select-points',
  templateUrl: './calibration-balance-edit-select-points.component.html',
  styleUrl: './calibration-balance-edit-select-points.component.scss',
  standalone: false
})
export class CalibrationBalanceEditSelectPointsComponent implements OnInit, OnDestroy {
  
  dataPoints: CalibrationBalanceVariablePoints[] = [];

  private destroy$ = new Subject<void>();
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogDataCalibrationSelectPoints,
    public dialogRef: MatDialogRef<CalibrationBalanceEditSelectPointsComponent>,
    private translate: TranslateService,
    public snackBarService: SnackBarService) {
  }
  
  ngOnInit(): void {
    this.data.points.forEach(ep => {
      ep.points.forEach(epp => {
        const indexPoint = this.data.pointsSelect?.find(dp => Number(dp.point) ===  Number(epp) && dp.uuidConfig === ep.uuidConfig);
        let point = new CalibrationBalanceVariablePoints();
        let include = true;
        point.value = epp;
        point.uuidConfig = ep.uuidConfig;
        point.uuidPattern = ep.uuidPattern;
        if (!indexPoint) {
          include = false;
        }
        point.include = include;
        this.dataPoints.push(point);
      });
    });
    
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public setValue(index: number, value: number | string | boolean | MatCheckboxChange, field: string): void {

    if (value == null || value === '') {
      value = null;
    } else if (value instanceof MatCheckboxChange) {
      value = value.checked;
    } else if (typeof value === 'string') {
      value = +value;
    }

    this.dataPoints[index][field] = value;
  }

  onOkClick(): void {
     const errs = [];

    const notSelected =  this.dataPoints.every(ep => !ep.include);
    if (notSelected && !this.data.isAsFound) {
      errs.push(this.translate.instant('calibrateEquipmentEdit.essay.points.error'));
    }
     if (errs.length === 0) {
      const points = this.dataPoints.filter(ef => ef.include);
      this.dialogRef.close(points);
    } else {
      const error = errs.join('\n');
      this.snackBarService.sendError(error);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
